export default {
    name: 'amscontrols',
    component(resolve) {
        require(['../components/pages/amscontrols/Show.vue'], resolve)
    },
    subRoutes: {
        '/ams-xl200-ctrls': {
            component(resolve) {
                require(['../components/pages/amscontrols/Xl200.vue'], resolve)
            }
        },
        '/eclipse': {
            component(resolve) {
                require(['../components/pages/amscontrols/Eclipse.vue'], resolve)
            }
        },
        '/pathfinder': {
            component(resolve) {
                require(['../components/pages/amscontrols/Pathfinder.vue'], resolve)
            }
        },
        '/certification': {
            component(resolve) {
                require(['../components/pages/amscontrols/Cert.vue'], resolve)
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/routermappings/amscontrols_rm_config.js